import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Box } from '@mui/system';

import sharedStyles from 'features/shared/Shared.module.scss';

import { ButtonSm } from 'features/shared/Buttons';
import NoindexTag from 'features/shared/NoindexTag';

import amplitudeHelper from 'helpers/Amplitude';

const page404 = `${process.env.REACT_APP_BASE_URL}/assets/images/404page.svg`;

// const handleClick = () => {};

const Error404Page = () => {
  const company = useSelector((state) => state.company);
  const user = useSelector((state) => state.user);
  const location = window.location.href;

  try {
    amplitudeHelper.logEvent('error_404', {
      location: location,
      company: company,
      user: { ...user, token: '' }
    });
  } catch (e) {
    console.log('Amplitude ERROR: ', e);
  }

  return (
    <>
      <NoindexTag />
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          flexDirection: 'column',
          padding: '0 20px',
          textAlign: 'center'
        }}>
        <img src={page404}></img>
        {/* <h1 style={{fontSize: 64, marginTop: -64, marginBottom: 0}}>🙊</h1> */}
        <h2 style={{ marginTop: '45px' }}>Oops! Page not found</h2>
        <div>The page does not exist or was removed</div>
        <ButtonSm
          component={Link}
          to='/'
          className={`${sharedStyles.mt100}`}
          style={{
            width: '350px',
            fontFamily: 'Montserrat',
            fontSize: '15px',
            fontWeight: '600'
          }}>
          Go back home
        </ButtonSm>
      </Box>
    </>
  );
};

export default Error404Page;
